function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M0 0h640v480H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M384.9 111h205.5l-.3 146.3c1.7 58.7-34.9 95.2-102.3 111.7-47.9-12-103-36.5-103.2-110l.3-148z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#00a2bd",
  stroke: "#000",
  strokeWidth: 1.8,
  d: "M389.4 115.4h196.4l-.2 140.2c1.6 56.3-33.4 91.2-97.8 107-45.8-11.4-98.5-35-98.6-105.4l.2-141.8z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#a53d08",
  d: "M584.3 272.2c-7.2 53.7-48.6 77.2-96.5 89.7-42.5-11.4-88.2-29.6-97-89.5l193.5-.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M480 141.5l-.3-17.6 14 .1.1 17.5H532l.1 13.7-38.3.2-.3 161.4-13.6.1-.2-161.7-38 .2v-14z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff9a08",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 0.8,
  d: "M449 278.8l35 36.3c12.1-13.3 3.7-63-12.2-72.1-1.9 5.9-5.1 13-8.6 15.2-7.5 5.2-26.1 11.2-19.9 15 1.4-1.9 5.1-3.7 6.9.6 2 6.9-7.8 7.3-7.8 7.3s-6.2-.8-7.3-7c-1-6.4 9.3-12.2 10.2-12.6.8-.3 14.3-4 16.6-15.9 2.9-11.8 5.8-10 6.3-10.2 17.7 1.7 29.2 33.3 29.9 55.5.6 22.2-9 37-10.8 38-1.7.9-42-47.9-42-47.9l3.8-2.2z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff9a08",
  stroke: "#000",
  strokeWidth: 0.8,
  d: "M474.6 245l.2 65.5M470.6 246.3l.3 59.4M466.4 254.9l.2 47.2M462.9 258.2l.2 39.1M459.2 260v33M455.2 262.6v26.1M451.7 264.7v20"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#ffdf00",
  strokeLinecap: "round",
  strokeWidth: 1.8
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.8,
  d: "M448.5 282.92l36.08 41.28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.34 256.92s16.32 35.76 1.2 65.12M444.26 275.4s1.2-3.12 2.72-1.84M441.46 266.28s-6.56 5.76-2.96 9.52",
  strokeWidth: 1.4400000000000002
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#008021",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M494 175.4c2.3-2 3.6-3.3 5.1-3 1.5.2 3.5 0 5-.4a31 31 0 0112-.4c1 .2 2.5.7 4.6 2.5 2.1 1.8 5.2 5 4.2 13.6s-.7 12.3-1.2 17.2c-.8 8.5-2.7 15.5-6 15 4.5 8 5 15 8 20.5s4.8 16.8 3.7 29c-1.2 12.3-4.4 39.7 5.3 58.2-1.6 1.1-5.5 0-9-3.7s-5-3.6-7.8-1.4c-8.8 6.7-17 14.8-29.1 6.7-2.8-1.8-3.6-4-1.6-9.7 5-14 7.5-33.4 6.7-42.4V175.4z"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  fill: "#ffe1cf",
  stroke: "#000",
  strokeWidth: 0.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M502.26 166.76a9.6 9.6 0 01-.08 6.8c-1.04 2.4-1.28 5.12.48 8.48 2.72-4 6.64-3.2 8.96-5.44 2.32-2.32 2.8-4.48 4.48-4.96-1.68-1.52-4.32-3.2-3.76-7.52.56-4.4 6.64-8 1.12-14.64a8 8 0 00-13.36 1.2c-.32.8.16 2.4-.72 3.44-.56.8-1.28 1.44-2.08 2-.48.4-.8.88-.24 1.6.24.24.64.24 1.04.4l-.8 1.44c-.32.32-.16.64.16.96-.48 1.36.4 1.6-.16 2.56-.56.88-1.2 2 .64 3.04.56.24 3.04.8 4.32.64zM479.78 189.8c-3.2.8-8.4-.64-12.32-.16-1.76.16-3.12-.72-2.88-2.4.24-1.76.48-4.4.08-6.88a31.6 31.6 0 013.84-14.72 32.96 32.96 0 003.84-11.68c0-1.84.16-3.84 1.76-4.88 1.2-.8 1.44-1.52 1.84-2.16.96-1.44 1.92-1.76 2-.88.08.48-.08.96-.56 1.6 1.04-.8 2.8-1.84 3.2-2.08.4-.32 2.4-1.76 2.56-.4.8-.4 1.36-.4 1.6 0 .16.56 0 .72-.32 1.04.56-.08 1.2.88 0 1.84.64-.24 1.28.8.16 1.68-1.04.96-2.4 1.6-2.72 2.4-.4.8-3.2 2.88-4.24 3.28-1.12.48-1.2 1.12-1.2 2.72 0 17.76-2.08 16.32-2.08 20.64 0 1.12-.24 2.16.88 1.84 1.2-.4 2.88-.88 4.56-.88v10zM480.5 228.04c5.2-2.64 11.2-3.6 14.32-4.4a62.4 62.4 0 0010.4-4.48c2.48-1.28 4.48-3.04 5.84-3.44a6.48 6.48 0 003.84-3.2 50.4 50.4 0 006.88-21.84c0-4-1.04-8.56-4.96-5.36a29.6 29.6 0 00-8.8 13.2c-1.6 6.4-2.96 7.84-3.28 9.12-.4 1.28-1.68 1.28-3.2 1.6a26.72 26.72 0 00-13.6 6.4 136 136 0 01-14.24 9.2c-3.68 2.08-4.4 2.24-5.2 4-.8 1.6-1.6 2.88-2.24 3.6-.72.8-.88 1.6-.8 2.56.16.8-.16 4.24-.24 5.36 0 1.2.24 1.44.72 1.52.4 0 1.04-.16 1.28-1.6-.24 1.44 1.68.96 1.76-.08 0 1.52 2 .64 2.08-.8 0 1.04 1.6.32 1.68-.08.4-1.2.64-2.4 1.12-3.36.64-1.36 1.36-3.12 2.72-4 1.52-1.12.8-2.4 3.92-4zM517.86 322.52c.32 1.28.96 2.72 1.2 3.6.24.8-.16 1.12-.4 1.6a32.8 32.8 0 00-2.72 8.8c-.08 1.2-.96 2.4-1.36 3.2-.48.8-.24 1.44.8 2.24.4.32 2-.16 2.16-.96.64.56 1.6.4 2.08-.48.56.48 1.44.16 2-.72.48.32 1.28-.32 1.6-.8.8.4 1.6-.08 1.6-1.6 0-.4.24-.96.48-1.28.24-.4.32-1.12.32-1.76 0-.64.32-1.92.88-2.8.56-.88 1.52-2.48 1.12-4-.4-1.36-.96-1.28-1.52-3.2-1.28-1.36-2.96-3.2-4.8-3.36-1.76-.08-2.8 1.12-3.44 1.52zM485.06 332.44c1.6 1.6 5.2 1.6 7.76-1.04-.88-.4-2.96-1.36-3.84-2.08-1.28 1.28-2.72 2.72-4 3.12z",
  strokeWidth: 0.32000000000000006
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#870f00",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M501.4 149c.6-4 3.5-4 5.3-3.5.8.1 2.6.3 4.4-.2 3.4-.9 6 .3 5.6 3.6 1 .7 2 2.3 1.7 3.7-.1 1.4.2 2 1.4 2.1 1.3.2 4 1.8 2.2 4 1.7 1 3 3.7 2.1 5.4-.9 1.8-3.6 2.1-4.8.5-1.3.6-3.3.7-4.6-.6-.9 1-3 .9-3.5 0-.4-1-1-1.4-1.9-1.7-.9-.3-1-2.8.4-3.1-.1-.8 0-1.6.3-2 .3-.4 0-1.2-.8-1.8-.8-.7-1.5-3-.7-4.4-1.4.5-4.4-.9-5-1.8-.7-1-1.6-1-2.1-.2z"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M502.26 166.76c2.24-.24 2.96-1.6 4.64-1.6M497.46 160.52l.56.32c.4.24.96.32 1.36.4M498.1 158.12l.96.56M503.3 149c-1.28-1.28 2.24-3.84 6-.16.8.72 2.48.72 3.04.56M508.5 151c1.76-.4 4.32-.4 5.12 1.6.8 1.92 2.24.64 3.44 2.96 1.2 2.32 3.12 4.88 4.96 3.12M514.66 163.96a4 4 0 01-.4-3.2c-.64-.8-.4-2.48 0-3.28M509.7 159.16c.08.72 1.04 2 2.4 2.24M519.3 164.6c-.8-1.04-.72-2-.48-3.2",
  strokeWidth: 0.32000000000000006
}), /*#__PURE__*/React.createElement("path", {
  d: "M510.9 153.08c0 1.04.56 2.4 1.6 2.88.32.64 1.44 2.24 3.76 2M516.74 148.92a10.88 10.88 0 00-5.28-2.48M502.66 182.04c-2 2.64-3.2 6.32-2.4 11.52.96 5.2 2.48 12.8-1.28 16.24M517.62 219.88c-2.64-.64-6.4-.64-8.56.88-2 1.52-5.52 1.6-7.84.48",
  strokeWidth: 0.32000000000000006
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.02 219.64c-2.32.4-3.36 2.08-3.36 6.32s-.96 10.48-.16 16.64M507.86 221.48c-1.6.4-3.12.4-2.8 4.48M500.02 226.04c.08-2.4.96-4.8 2.56-4.32M516.66 226.6c.08-5.6-1.12-7.12-2.72-7.04 2.16 0 3.68.32 4.64 9.28.64 6.72 2.08 9.04 3.68 14.32 4.16 13.6 2.08 34.56 4.16 42M513.46 228.2c4.4 12.64 6.72 26.72-.4 49.28 4.8 13.44 9.6 23.12 10.56 28.64M499.7 258.12c.8-2.88-2.16-3.2.4-13.36 1.12-4.4 1.28-7.04.56-8.4M500.66 242.36c-1.04 4.48 3.36 12.88 1.2 19.04M496.42 262.52c0 4 .88 9.04.72 12.96-.24 3.92 1.36 5.68 3.2 9.44 6.72 13.36 11.2 22.88 10.64 35.52-.16 2.32.64 7.2-1.76 8.56M496.58 332.36c.72 0 1.44-.32 2.32-2.4a64.8 64.8 0 002.4-23.04M502.74 316.6c.32 2.64.32 8.08-1.36 12.4M507.14 308.68c1.04 5.6.88 10.72.08 14.32M504.82 323c.16 2.24 1.2 8-.56 8.48M513.46 296.2c4.32 6.72 7.6 23.2 11.2 26.64M517.14 320.2c-.08-1.84-.16-4.4-1.2-5.6M471.06 239.4c.08-1.2-.16-2.4 1.28-4.4M468.98 240.2c.24-4.4.16-4.8 1.44-6.08M467.22 240.28c0-3.2-.32-4.24.96-6.24M483.14 145.16l-4.56 3.44M484.42 146.2c-.56.08-2.16 1.44-4.96 3.6M484.5 148.04c-.96.4-2.64 2-4.16 3.12M477.38 147.72l-1.6 1.6M517.54 341c-.24-.24-.24-1.28.24-2.4M519.7 340.52c-.4-.32 0-1.76.24-2.64M521.62 339.8c-.4-.16-.48-.96 0-2.08M523.14 339c-.24-.08-.32-.56.08-1.76",
  strokeWidth: 0.32000000000000006
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M500.5 152.68c.8 1.04 1.68.96 1.84 1.6.16.8.24.8.4 1.04.16.16-.4.16-.64 0h-1.36c-.4 0-.88-.56-.64-.56.32-.08.32-.16.24-.4 0-.24.16-.56.32-.64l-.08-.32c-.16-.32-.32-.96-.08-.8zM500.98 151.64a6.4 6.4 0 013.44 1.6c.64.8.08.56-.24.56s-1.04-.16-1.36-.64a4.64 4.64 0 00-1.92-1.12c-.32-.08-.64-.48.08-.4z"
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M0 0h320v240H0z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M37.5 0l122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M212 140.5L320 220v20l-135.5-99.5zm-92 10l3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M120.5 0v240h80V0zM0 80v80h320V80z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
});

var SvgMs = function SvgMs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

export default SvgMs;